// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1__pQ","cls2":"Banner-cls2_A2g Banner-cls1__pQ"};